<template>
  <v-container fluid grid-list-md fill-height style="padding:0px 10px 5px 10px;width:100%;">
    <v-layout row>
      <v-flex d-flex md4>
        <v-card>
          <v-card-title primary class="title" style="height:5%;">Fault list</v-card-title>
          <v-card-text style="height:90%;">
            <v-layout v-if="enginefaults.length > 0" column fill-height style="overflow:auto;">
              <!--              <FaultCard :ref="fault.Id" v-for="fault in enginefaults" :key="fault" v-on:faultChange="selFaultChange(fault)" v-bind:currentFault="fault" v-bind:kpi="kpi" v-bind:selFaultId="selectedFaultId" v-bind:selFaultDate="selectedFaultDate"></FaultCard>-->
              <FaultCard :ref="fault.Id" v-for="fault in selected_faults" :key="fault" v-on:faultChange="selFaultChange(fault)" v-bind:currentFault="fault" v-bind:kpi="kpi" v-bind:selFaultId="selectedFaultId" v-bind:selFaultDate="selectedFaultDate"></FaultCard>
            </v-layout>
            <div v-else class="title" style="display:flex;justify-content:center;align-items:center;width:100%;height:100%;color:rgb(219,219,219);">No Faults Detected</div>
          </v-card-text>
          <v-card-actions style="height:5%;">
            <v-layout row>
              <v-flex d-flex md4>
                <v-btn :disabled="disabled" style="color:white; background-color: rgb(51,82,128);" @click="showDialog=true">Request Remote Support</v-btn>
              </v-flex>
              <v-flex d-flex md8>
                <div v-if="fault_pages.max > 0" class="page_list_container" style="">
                  <ul class="page_list" style="">
                    <!--                    <li class=page_list_item><a style="max-height: 16px; max-width: 16px; width: 16px; color:rgb(51,82,128); padding: 0 8px;"><i class="fa fa-angle-double-left"/></a></li>-->
                    <li v-if="fault_pages.max > 4 && 1 != fault_pages.current" class="page_list_item"><a @click="selectFaultPage(fault_pages.current - 1)"><i class="fa fa-angle-left"/></a></li>
                    <li :class="'page_list_item ' + (1 == fault_pages.current ? 'current' : '')"><a @click="selectFaultPage(1)">1</a></li>
                    <li v-if="fault_pages.current - 1 > 2" class="page_list_item"><p>...</p></li>

                    <li :class="'page_list_item ' + (page == fault_pages.current ? 'current' : '')" v-for="page in middlePages" :key="page"><a @click="selectFaultPage(page)">{{ page }}</a></li>

                    <li v-if="fault_pages.max > 5 && fault_pages.current + 1 < fault_pages.max - 1" class="page_list_item"><p>...</p></li>

                    <li v-if="fault_pages.max > 1 && middlePages.indexOf(fault_pages.max) < 0" :class="'page_list_item ' + (fault_pages.max == fault_pages.current ? 'current' : '')"><a @click="selectFaultPage(fault_pages.max)">{{ fault_pages.max }}</a></li>

                    <li v-if="fault_pages.max > 4 && fault_pages.max != fault_pages.current" class="page_list_item"><a @click="selectFaultPage(fault_pages.current + 1)"><i class="fa fa-angle-right"/></a></li>
                    <!--                    <li class=page_list_item><a style="max-height: 16px; max-width: 16px; width: 16px; color:rgb(51,82,128); padding: 0 8px;"><i class="fa fa-angle-double-right"/></a></li>-->
                  </ul>
                </div>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex d-flex md8>
        <v-tabs v-model="active" slider-color="rgb(51,82,128)" style="height:100%;width:100%;">
          <v-tab v-for="title in tabTitles" :key="title" ripple active-class='activeTab' style="text-transform:none;color:rgb(192,192,192);">
            <span>{{ title }}</span>
          </v-tab>
          <v-tab-item class="tabItem" style="padding-bottom: 4px">
            <EngineFaultsDataNewRules v-if="selFault && selFault.subsystem" v-bind:fault="selFault" v-bind:active="tabActive[0]"/>            
            <EngineFaultsData v-else v-bind:fault="selFault" v-bind:active="tabActive[0]"/>
          </v-tab-item>
          <v-tab-item class="tabItem" style="padding-bottom: 4px">
            <EngineFaultsDetailsNewRules v-if="selFault && selFault.subsystem" v-bind:fault="selFault" v-bind:active="tabActive[1]"/>
            <EngineFaultsDetails v-else  v-bind:fault="selFault" v-bind:active="tabActive[1]"/>
          </v-tab-item>
        </v-tabs>
      </v-flex>
      <v-dialog v-model="showDialog" width="400" height="600">
        <v-card style="width:400px;height:600px;">
          <v-card-title primary class="title" style="height:10%;">Create A Ticket</v-card-title>
          <v-card-text style="height:80%;">
            <v-layout column fill-height>
              <v-flex>
                <v-layout row>
                  <v-flex d-flex md4 style="font-size: 16px !important; font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; padding: 5px;align-items:center;">Type</v-flex>
                  <v-flex d-flex md8 style="font-size: 16px !important; font-weight: 300; line-height: 1 !important;letter-spacing: 0.02em !important; padding: 5px;align-items:center;">
                    <div>Support</div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-for="(field) in labels" :key="field">
                <v-layout row>
                  <v-flex d-flex md4 style="font-size: 16px !important; font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; padding: 5px;align-items:center;">{{ field }}</v-flex>
                  <v-flex d-flex md8 style="font-size: 16px !important; font-weight: 300; line-height: 1 !important;letter-spacing: 0.02em !important; padding: 5px;align-items:center;">
                    <div v-if="display.indexOf(field) > -1">{{ ticketModels[field] }}</div>
                    <v-text-field v-else v-model="ticketModels[field]"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex style="min-height:100px;">
                <v-layout row style="width:100%;height:100%;">
                  <v-flex d-flex md4 style="font-size: 16px !important; font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; padding: 5px;">Message</v-flex>
                  <v-flex d-flex md8 style="font-size: 16px !important; font-weight: 300; line-height: 1 !important;letter-spacing: 0.02em !important; padding: 5px;align-items:center;">
                    <v-textarea auto-grow outline v-model="ticketModels['Message']"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions style="height:10%;">
            <v-spacer/>
            <v-btn color="primary" flat @click="cancelDialog">Cancel</v-btn>
            <v-btn style="color:white; background-color: rgb(51,82,128);" @click="sendTicket">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showError" max-width="300px">
        <v-alert class='alert' :value="error" type="info" transition="scale-transition" color='rgb(51,82,128)' outline>{{ error }}</v-alert>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable no-console */
import EngineFaultsData from "./EngineFaultsData"
import EngineFaultsDetails from "./EngineFaultsDetails"
import EngineFaultsDataNewRules from "./EngineFaultsDataNewRules"
import EngineFaultsDetailsNewRules from "./EngineFaultsDetailsNewRules"
import FaultCard from '../controls/FaultCard'
import {globalStore} from "../main.js"
import {vessels} from "../main.js"
import axios from 'axios';

export default {
  name: 'EngineFaults',
  components: {
    EngineFaultsData,
    EngineFaultsDetails,
    EngineFaultsDataNewRules,
    EngineFaultsDetailsNewRules,
    FaultCard
  },
  props: {
    date: String,
    eng: String,
    id: Number
  },
  data() {
    return {
      active: parseInt(this.$route.query.tab),
      tabTitles: ['Fault Data', 'Details'],
      kpi: {},
      selectedFaultId: -1,
      selectedFaultDate: false,
      tabActive: [false, false],
      showDialog: false,
      showError: false,
      error: "",
      ticketModels: {},
      profileFields: ['displayName', 'email'],
      labels: ['Username', 'Email', 'Title'],
      display: ['Username', 'Email'],
      disabled: false,
      fault_pages: {
        current: 1,
        max: 7
      },
      selected_faults: []
    }
  },
  created() {
    this.tabActive[parseInt(this.$route.query.tab)] = true;

    for (let i = 0; i < this.profileFields.length; i++) {
      this.ticketModels[this.labels[i]] = globalStore.userProfile[this.profileFields[i]];
    }

    this.ticketModels['Type'] = ['Support'];
    this.ticketModels['Message'] = '';
    this.ticketModels['Title'] = '';
  },
  mounted() {
    if ('id' in this.$route.params && this.enginefaults.length) {
      this.selectedFaultId = this.$route.params.id;
      this.selectedFaultDate = this.enginefaults.find(fault => fault.Id == this.$route.params.id).endDate;
      this.$refs[this.$route.params.id][0].$el.scrollIntoView({behavior: 'smooth'})
    } else if (this.enginefaults.length > 0) {
      this.selectedFaultDate = this.enginefaults[0].endDate;
      this.selectedFaultId = this.enginefaults[0].Id;
    }

    if (globalStore.selectFaultId != null) {
      this.selectedFaultId = parseInt(globalStore.selectFaultId);
    }

    setTimeout(() => {
      this.dismishNotification();
    }, 250);
  },
  methods: {
    selFaultChange(event) {
      this.selectedFaultId = event.Id;
      this.selectedFaultDate = event.endDate;
    },
    sendTicket() {
      var bodyFormData = new FormData();
      bodyFormData.set("type", "1");
      bodyFormData.set("vessel", globalStore.selectedIMO);
      bodyFormData.set("subject", this.ticketModels['Title']);
      bodyFormData.set("msg", this.ticketModels['Message']);
      bodyFormData.set("component", this.selFault['subComponent']);
      bodyFormData.set("subsystem", this.selFault['component']);
      bodyFormData.set("fault_id", this.selFault['Id']);
      bodyFormData.set("fault_date", this.selFault['endDate'].split(' ')[0]);
      bodyFormData.set("fault_engine", globalStore.selectedEngine);

      axios({
        method: 'post',
        url: globalStore.config.api_location + '/tickets/create',
        data: bodyFormData,
        config: {headers: {'Content-Type': 'multipart/form-data'}},
        headers: {Authorization: globalStore.auth_token}
      })
          .then((response) => {
            if (response.data.success) {
              for (var i in globalStore.faults) {
                if (globalStore.faults.hasOwnProperty(i) && globalStore.faults[i].Id == this.selectedFaultId && globalStore.faults[i].endDate == this.selectedFaultDate) {
                  globalStore.faults[i].hasTicket = true;
                  this.showError = true;
                  this.error = "Ticket created successfully";
                }
              }
            } else {
              if (Object.keys(response.data).indexOf('msg')) {
                this.showError = true;
                this.error = response.data.msg;
              }
            }
          })
          .catch(function (error) {
          });

      this.showDialog = false;
    },
    cancelDialog() {
      this.showDialog = false;
    },
    dismishNotification() {
      if (globalStore.notificationId != null) {
        axios.post(globalStore.config.api_location + '/notifications/dismish/', {selected: [globalStore.notificationId]}, {headers: {Authorization: globalStore.auth_token}}).then((response) => {
          globalStore.notificationId = null;
          globalStore.alerts = response.data.data;
        }).catch(() => {
          globalStore.notificationId = null;
        });
      }
    },
    selectFaultPage(page) {
      this.fault_pages.current = page;
    },
    displayFaults(page_priority) {
      if (typeof page_priority == 'undefined') {
        page_priority = false;
      }

      // this.$route.params.id = 6595

      if (this.enginefaults.length > 0) {
        if ('id' in this.$route.params && !page_priority) {
          this.selectedFaultId = this.$route.params.id;
          let selected_fault = this.enginefaults.find(fault => fault.Id == this.$route.params.id);

          this.selectedFaultDate = selected_fault.endDate

          let selected_index = this.enginefaults.findIndex((element) => {
                return element.Id == this.$route.params.id
              }),
              page = Math.floor(selected_index / 20),
              start = page * 20,
              end = start + 20;

          this.selected_faults = this.enginefaults.slice(start, end);
          // this.$refs[this.$route.params.id][0].$el.scrollIntoView({behavior: 'smooth'});
          this.fault_pages.current = page;
        } else {
          console.log(this.fault_pages.current);
          this.selected_faults = this.enginefaults.slice(20 * (this.fault_pages.current - 1), 20 * this.fault_pages.current);
          this.selectedFaultDate = this.enginefaults[0].endDate;
          this.selectedFaultId = this.enginefaults[0].Id;
        }
      }
    }
  },
  computed: {
    selFault: function () {
      var selected = this.enginefaults.filter(function (item) {
        if (this.selectedFaultDate) {
          return item.Id == this.selectedFaultId && item.endDate == this.selectedFaultDate;
        } else {
          return item.Id == this.selectedFaultId;
        }
      }, this);
      
      return selected[0];
    },
    enginefaults: function () {

      var faults = globalStore.faults.sort(function (a, b) {
        return new Date(a.endDate) - new Date(b.endDate);
      });

      return faults;
    },
    selFromAlertId: function () {
      return globalStore.selectFaultId;
    },
    notificationId: function () {
      return globalStore.notificationId;
    },
    alertDate: function () {
      return globalStore.alertDate
    },
    middlePages: function () {
      let pages = []

      if (this.fault_pages.current == 1) {
        for (var i = 2; i <= 4; i++) {
          if (i < this.fault_pages.max) {
            pages.push(i)
          }
        }
      } else if (this.fault_pages.current == this.fault_pages.max) {
        for (var i = 3; i > 0; i--) {
          if (this.fault_pages.max - i > 1) {
            pages.push(this.fault_pages.max - i)
          }
        }
      } else {
        if (this.fault_pages.current - 1 > 1) {
          pages.push(this.fault_pages.current - 1)
        }

        pages.push(this.fault_pages.current)

        if (this.fault_pages.current + 1 < this.fault_pages.max) {
          pages.push(this.fault_pages.current + 1)
        }

        if (pages.length < 3) {
          if (this.fault_pages.current == 2 && this.fault_pages.current + 2 < this.fault_pages.max) {
            pages.push(this.fault_pages.current + 2)
          }
          if (this.fault_pages.current == this.fault_pages.max - 1 && this.fault_pages.current - 2 > 1) {
            pages = [this.fault_pages.current - 2].concat(pages)
          }
        }
      }

      return pages
    },
    currentPage: function () {
      return this.fault_pages.current
    }
  },
  watch: {
    selFromAlertId: function () {
      this.selectedFaultId = this.selFromAlertId;

      var selected = this.enginefaults.find(function (item) {
        return item.Id == this.selectedFaultId;
      }, this);

      if (selected) {
        this.selectedFaultDate = selected.endDate;
      }
    },
    active: function () {
      for (let i = 0; i < this.tabActive.length; i++) {
        if (i == this.active)
          this.tabActive[i] = true;
        else
          this.tabActive[i] = false;
      }
    },
    showDialog: function () {
      if (this.showDialog == true) {
        this.ticketModels['Title'] = this.selFault.fault;
      }
    },
    enginefaults: {
      handler: function () {
        this.fault_pages.current = 1;
        this.fault_pages.max = Math.ceil(this.enginefaults.length / 20);
        this.displayFaults();
      },
      deep: true,
      immediate: true
    },
    currentPage: function () {
      this.displayFaults();
    },
    selFault: function () {
      if (this.selFault) {
        this.disabled = this.selFault.hasTicket
      }
    },
    notificationId: function () {
      if (globalStore.notificationId != null) {
        this.dismishNotification();
      }
    },
    alertDate: function (newValue) {
      this.selectedFaultDate = newValue;
    }
  }
}
</script>

<style scoped>
.tabItem {
  height: calc(100vh - 157px)
}

.page_list_container {
  height: 35px;
  max-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page_list {
  display: flex;
  list-style: none;
  flex-direction: row;
  padding: 0;
  margin: 0;
}

.page_list_item a, .page_list_item p {
  max-height: 16px;
  max-width: 16px;
  width: 16px;
  color: rgb(51, 82, 128);
  padding: 0 8px;
  margin: 0;
}

.page_list_item.current a {
  font-weight: bold;
  border-bottom: 1px solid rgb(51, 82, 128);
}
</style>
